import {
	Box,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	Checkbox,
	FormControlLabel,
	// Link as MuiLink,
	Typography
} from '@mui/material'
import { noop } from 'lodash'
// import { NavLink } from 'react-router'

export default function PlanItem({
	name,
	title,
	description,
	image,
	onChange = noop,
	selected = false
}: any) {
	return (
		<Box sx={styles.root}>
			<Card
				sx={{
					...styles.card,
					border: selected ? '2px solid rgb(90, 244, 5)' : '2px solid transparent'
				}}
			>
				<CardMedia component={'img'} image={image} alt={title} sx={styles.media} />
				<CardContent sx={styles.content}>
					<Box sx={{ display: 'flex', flex: 1 }}>
						<Typography variant="h3" sx={{ fontSize: '1.2rem', mb: 2 }}>
							{title}
						</Typography>
						<Typography variant="body2">{description}</Typography>
					</Box>
					{/* <Box>
						<MuiLink color="primary" component={NavLink} to="/recipes/chicken-and-grains">
							See Details
						</MuiLink>
					</Box> */}
				</CardContent>
				<CardActions sx={{ pl: 2, pr: 2 }}>
					<FormControlLabel
						label="Add"
						control={
							<Checkbox
								name={name}
								checked={selected}
								onChange={({ target }: any) => onChange(!!target.checked)}
							/>
						}
					/>
				</CardActions>
			</Card>
		</Box>
	)
}

const styles = {
	root: { position: 'relative', pt: '100px', maxWidth: 400, width: '100%' },
	card: {
		borderRadius: 3,
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		'&.MuiPaper-root': {
			boxShadow:
				'0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);'
		}
	},
	media: {
		position: 'absolute',
		transform: 'translate(-50%, -50%)',
		left: '50%',
		maxWidth: 200
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		pt: '100px',
		flex: 1,
		minHeight: 200
		// maxWidth: 200
	}
}
